import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// components
import CardStats from "components/Cards/CardStats.js";

export default function HeaderStats() {
  const [employeeCount, setEmployeeCount] = useState("Loading...");
  const [vendorCount, setVendorCount] = useState("Loading...");
  const [serviceCount, setServiceCount] = useState("Loading...");
  const [userCount, setUserCount] = useState("Loading...");
  const navigate = useNavigate();

  useEffect(() => {
    // --------------------------- EMPLOYEE COUNT ---------------------------
    axios
  .get("https://visitguru.in/api/v1/employee/getEmp")
  .then((res) => {
    if (res.data.success) {
      const total = res.data.pagination?.totalRecords;
      setEmployeeCount(total);
    } else {
      setEmployeeCount("Error");
    }
  })
  .catch(() => setEmployeeCount("Error"));


    // --------------------------- VENDOR COUNT ---------------------------
    axios
      .get("https://visitguru.in/api/v1/freelancer/getAllfreelancer")
      .then((res) => {
        if (res.data.success) {
          setVendorCount(res.data.totalFreelancers);
        } else {
          setVendorCount("Error");
        }
      })
      .catch(() => setVendorCount("Error"));

    // --------------------------- USER COUNT ---------------------------
    axios
      .get("https://visitguru.in/api/v1/user/getAlluser")
      .then((res) => {
        if (res.data.success) {
          // API returns pagination + totalUsers
          const total =
            res.data.totalUsers ||
            res.data.pagination?.totalRecords ||            
            res.data.data?.length ||
            0;

          setUserCount(total);
        } else {
          setUserCount("Error");
        }
      })
      .catch(() => setUserCount("Error"));

    // --------------------------- SERVICE COUNT ---------------------------
    axios
      .get("https://visitguru.in/api/v1/service/getService")
      .then((res) => {
        if (res.data.success) {
          setServiceCount(res.data.totalServices);
        } else {
          setServiceCount("Error");
        }
      })
      .catch(() => setServiceCount("Error"));
  }, []);

  return (
    <>
      {/* Header */}
      <div className="relative bg-lightBlue-600 md:pt-32 pb-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap">

              {/* EMPLOYEE */}
              <div
                className="w-full lg:w-6/12 xl:w-3/12 px-4"
                onClick={() => navigate("/admin/employee")}
              >
                <CardStats
                  statSubtitle="Employee"
                  statTitle={employeeCount}
                  statArrow="up"
                  statPercent="3.48"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Since last month"
                  statIconName="fas fa-user-tie"
                  statIconColor="bg-red-500"
                />
              </div>

              {/* VENDORS */}
              <div
                className="w-full lg:w-6/12 xl:w-3/12 px-4"
                onClick={() => navigate("/admin/vendor")}
              >
                <CardStats
                  statSubtitle="Vendors"
                  statTitle={vendorCount}
                  statArrow="down"
                  statPercent="3.48"
                  statPercentColor="text-red-500"
                  statDescripiron="Since last week"
                  statIconName="fas fa-users"
                  statIconColor="bg-orange-500"
                />
              </div>

              {/* CUSTOMERS */}
              <div
                className="w-full lg:w-6/12 xl:w-3/12 px-4"
                onClick={() => navigate("/admin/user")}
              >
                <CardStats
                  statSubtitle="Customers"
                  statTitle={userCount}
                  statArrow="down"
                  statPercent="1.10"
                  statPercentColor="text-orange-500"
                  statDescripiron="Since yesterday"
                  statIconName="fas fa-user"
                  statIconColor="bg-pink-500"
                />
              </div>

              {/* SERVICES */}
              <div
                className="w-full lg:w-6/12 xl:w-3/12 px-4"
                onClick={() => navigate("/admin/service")}
              >
                <CardStats
                  statSubtitle="Services"
                  statTitle={serviceCount}
                  statArrow="up"
                  statPercent="12"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Since last month"
                  statIconName="fas fa-toolbox"
                  statIconColor="bg-lightBlue-500"
                />
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
